import React, { useRef } from "react";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

import { useAppStore } from "../../providers/AppStoreProvider";
import { CircleProgressBar } from "../../components/ProgressBar/CircleProgressBar";
import useCookie from "../../hooks/useCookies";

export const CourseProgress = observer(() => {
  const store = useAppStore();
  const addToCartBtnRef = useRef();
  const [cartCookie, setCartCookie] = useCookie("elearning", '{ "courses": [], "bundles": [] }');

  const openRatingModalHandler = () => {
    store.ratingModal.setMode(
      store.review && Object.keys(store.review)?.length ? "edit" : "create",
    );
    store.ratingModal.toggle();
  };

  const addToCartHandler = () => {
    const newCart = JSON.parse(cartCookie);
    newCart.courses.push(store.course.id);

    cart.add(addToCartBtnRef.current);
    setCartCookie(JSON.stringify(newCart));
  };

  return (
    <div className="course-progress rounded-20 mb-2 p-4">
      <div className="d-flex flex-row justify-content-between align-items-center">
        <a href={`/courses/${store.course.id}`} className="me-4">
          <div className="fs-5 fw-bold text-dark lh-sm mb-2">{store.course.name}</div>
          <span className="fs-7 text-secondary">Giảng viên {store.course.author.name}</span>
        </a>
        <div>
          <CircleProgressBar size="4rem" percentage={(store.progress * 100).toFixed(0)} />
        </div>
      </div>

      {store.hasPermission("view_private_lesson") && store.hasPermission("create_review") && (
        <div
          role="button"
          className="rating-btn d-flex justify-content-center align-items-center rounded-10 mt-3 p-3"
          onClick={openRatingModalHandler}
        >
          <FontAwesomeIcon icon={faStar} className="me-2" />
          <span className="lh-sm fw-semibold">
            {store.review && Object.keys(store.review)?.length ? "Sửa đánh giá" : "Đánh giá"} khoá
            học
          </span>
        </div>
      )}

      {!store.hasPermission("view_private_lesson") &&
        (JSON.parse(cartCookie).courses.includes(store.course.id) ? (
          <a
            href="/checkout"
            className="checkout-btn bg-gradient d-flex flex-row justify-content-between align-items-center rounded-10 mt-3 p-3 px-4"
          >
            <span className="fw-semibold">Mua khoá học ngay</span>
            <i class="fa-duotone fa-fire fa-lg"></i>
          </a>
        ) : (
          <div data-product-id={store.course.id} className="card-product course">
            <div
              role="button"
              className="add-to-cart-btn d-flex flex-row justify-content-between align-items-center rounded-10 mt-3 p-3 px-4"
              ref={addToCartBtnRef}
              onClick={addToCartHandler}
            >
              <div className="d-flex flex-column">
                <div className="fw-semibold">
                  {new Intl.NumberFormat().format(store.course.discountPrice())} VNĐ
                </div>
                <del className="fs-8">{new Intl.NumberFormat().format(store.course.price)} VNĐ</del>
              </div>
              <i className="fa-duotone fa-cart-arrow-down fa-lg"></i>
            </div>
          </div>
        ))}
    </div>
  );
});
